var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        side: 'top',
        content: true,
        customClass: 'bg-dark text-white',
        content: _vm.showTooltip ? _vm.status.tooltip : ''
    }),expression:"{\n        side: 'top',\n        content: true,\n        customClass: 'bg-dark text-white',\n        content: showTooltip ? status.tooltip : ''\n    }"}],staticClass:"status",class:_vm.status.class},[_c('span',[_vm._v(_vm._s(_vm.status.label))]),(_vm.status.icon || _vm.showIcon)?_c('a-icon',{staticStyle:{"margin-right":"-6px"},attrs:{"icon":_vm.status.icon || 'Info'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }